import {Select, SelectProps} from "@mantine/core";
import {Provinces} from "./Provinces";

interface Props extends Omit<SelectProps, "data"> {

}

function VietnamProvince(props: Props) {

    function serializeProvinces() {
        return Provinces.map((prov) => ({value: prov.code, label: `${prov.name}`}))
    }

    return (
        <Select {...props} data={serializeProvinces()}/>
    )

}

export default VietnamProvince;